import React from "react";

import { motion } from "framer-motion";

export default function LoadingSplash() {

  return (
    <motion.div

      className="
        fixed inset-0

        z-[10000]

        flex items-center justify-center

        overflow-hidden

        bg-[#08060D]
      "

      initial={{ opacity: 1 }}

      animate={{ opacity: 1 }}

      exit={{ opacity: 0 }}

      data-testid="loading-splash"
    >

      {/* ===================================================== */}
      {/* BACKGROUND GLOW */}
      {/* ===================================================== */}

      <div
        className="
          absolute

          top-1/2 left-1/2

          -translate-x-1/2
          -translate-y-1/2

          w-[320px]
          sm:w-[600px]

          h-[320px]
          sm:h-[600px]

          bg-purple-500/10

          rounded-full

          blur-[100px]
          sm:blur-[140px]
        "
      />

      {/* SECONDARY GLOW */}

      <div
        className="
          absolute

          top-[40%]
          left-[55%]

          -translate-x-1/2
          -translate-y-1/2

          w-[220px]
          sm:w-[350px]

          h-[220px]
          sm:h-[350px]

          bg-fuchsia-400/10

          rounded-full

          blur-[80px]
          sm:blur-[120px]
        "
      />

      {/* EXTRA MOBILE GLOW */}

      <div
        className="
          absolute

          bottom-[-120px]
          left-[-60px]

          w-[240px]
          h-[240px]

          bg-violet-500/10

          rounded-full

          blur-[90px]

          sm:hidden
        "
      />

      {/* ===================================================== */}
      {/* GRID */}
      {/* ===================================================== */}

      <div
        className="
          absolute inset-0

          opacity-[0.04]

          grid-bg
        "
      />

      {/* ===================================================== */}
      {/* CONTENT */}
      {/* ===================================================== */}

      <div className="relative text-center px-6">

        {/* ===================================================== */}
        {/* SPINNER */}
        {/* ===================================================== */}

        <motion.div

          className="
            relative

            w-24 h-24
            sm:w-28 sm:h-28

            mx-auto

            mb-6 sm:mb-8
          "

          animate={{
            rotate: 360,
          }}

          transition={{
            repeat: Infinity,
            duration: 2.2,
            ease: "linear",
          }}
        >

          {/* OUTER RING */}

          <div
            className="
              absolute inset-0

              rounded-full

              border border-purple-500/20
            "
          />

          {/* ANIMATED RING */}

          <div
            className="
              absolute inset-0

              rounded-full

              border-t-2
              border-r-2

              border-purple-400
            "

            style={{
              filter:
                `
                  drop-shadow(0 0 18px rgba(168,85,247,0.7))
                `,
            }}
          />

          {/* INNER GLASS */}

          <div
            className="
              absolute inset-4

              rounded-full

              bg-white/[0.03]

              backdrop-blur-xl

              border border-white/5
            "
          />

          {/* CENTER GLOW */}

          <div
            className="
              absolute inset-6
              sm:inset-7

              rounded-full

              bg-gradient-to-br
              from-[#6D3B8C]
              via-[#9B4D96]
              to-[#C67BCF]

              opacity-20

              blur-xl
            "
          />

          {/* LOGO */}

          <div
            className="
              absolute inset-0

              flex items-center justify-center
            "
          >

            <span
              className="
                text-transparent

                bg-gradient-to-r
                from-[#B86BC5]
                to-[#E3B6F2]

                bg-clip-text

                font-bold

                text-2xl
                sm:text-3xl
              "
              style={{
                fontFamily: "Sora",
              }}
            >
              C
            </span>

          </div>

        </motion.div>

        {/* ===================================================== */}
        {/* BRAND NAME */}
        {/* ===================================================== */}

        <motion.h2

          className="
            text-lg
            sm:text-xl

            font-semibold

            tracking-[0.16em]
            sm:tracking-[0.2em]

            uppercase

            text-white/90
          "

          animate={{
            opacity: [0.7, 1, 0.7],
          }}

          transition={{
            repeat: Infinity,
            duration: 2,
          }}

          style={{
            fontFamily: "Sora",
          }}
        >

          CodeFix Solutions

        </motion.h2>

        {/* ===================================================== */}
        {/* LOADING TEXT */}
        {/* ===================================================== */}

        <motion.p

          className="
            mt-3

            text-[10px]
            sm:text-xs

            tracking-[0.22em]
            sm:tracking-[0.35em]

            uppercase

            text-purple-200/60
          "

          animate={{
            opacity: [0.3, 1, 0.3],
          }}

          transition={{
            repeat: Infinity,
            duration: 1.8,
          }}
        >

          Initializing Experience

        </motion.p>

      </div>

    </motion.div>
  );
}